import { DewiColorsBlue4 } from '@styles/tokens/dist/js/tokens'
import { IconButton as Button, styled } from '@mui/material'
import { hslStringToRgba } from '@utils/helpers'
import { CSSProperties } from 'react'

export const DialogActionButton = styled(Button)({
  background: 'var(--dewi_colors_dark_4)',
  width: '32px',
  height: '32px',
  paddding: '0.25rem',
  color: 'var(--dewi_colors_dark_4)',
  '&:hover': {
    color: 'var(--dewi_colors_dark_0)',
    background: 'var(--dewi_colors_dark_7)',
  },
})

const IconWrapper = styled('div')({
  background: 'var(--dewi_colors_dark_7)',
  paddding: '0.125rem',
  color: 'var(--dewi_colors_gray_0)',
  width: '48px',
  height: '48px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  '> .MuiSvgIcon-root, > svg': {
    height: '1.6rem',
    width: '1.6rem',
  },
})

type CircleIconProps = {
  Icon: any // TODO: replace any with correct type
  style?: CSSProperties
}

export const DialogIconWrapper = ({ Icon, style }: CircleIconProps) => {
  return (
    <IconWrapper style={style}>
      <Icon />
    </IconWrapper>
  )
}

export const DialogLogoWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  height: '4.75rem',
  width: '4.75rem',
  overflow: 'hidden',
  backgroundColor: hslStringToRgba(DewiColorsBlue4, 0.2),
})
